import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

type Toast = {
  id: number;
  color: string;
  title: string;
  text: string;
  removeAction: () => void;
  autohide: boolean;
};

export type uiState = {
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any;
  dashboard: string;
  message: string;
  sidebarShow: boolean;
  asideShow: boolean;
  theme: string;
  sidebarUnfoldable: boolean;
  toasts: Toast[];
};

const initialState: uiState = {
  loading: false,
  errors: {},
  dashboard: 'none',
  message: '',
  sidebarShow: true,
  asideShow: false,
  theme: 'default',
  sidebarUnfoldable: false,
  toasts: [],
};

const uiSlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.loading = false;
      state.errors = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDashboard: (state, action) => {
      state.dashboard = action.payload;
    },
    setAside: (state, action) => {
      state.asideShow = action.payload;
    },
    setSidebarShow: (state, action) => {
      state.sidebarShow = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setSidebarUnfoldable: (state, action) => {
      state.sidebarUnfoldable = action.payload;
    },
    addToast: (state, action) => {
      state.toasts = [action.payload, ...state.toasts];
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
  },
});

export const {
  setErrors,
  setMessage,
  setLoading,
  setDashboard,
  setAside,
  setSidebarShow,
  setTheme,
  setSidebarUnfoldable,
  addToast,
  removeToast,
} = uiSlice.actions;

export default uiSlice;

export const selectCurrentErrors = (state: RootState) => state.UI.errors;
export const selectCurrentLoading = (state: RootState) => state.UI.loading;
export const selectCurrentSidebarShow = (state: RootState) => state.UI.sidebarShow;
